import { Row } from "react-bootstrap";
import fieldSection from "../../../formJsonData/Purchase/PurchaseListing/PurchasingForm.json";
import { useState } from "react";
import { handlePOCreatByItems } from "../commonHandlerFunction/Purchase/PurchaseOrder/PurchaseOrderHandler";
import { Link, useNavigate } from "react-router-dom";
import { encryptDataForURL } from "../../../utills/useCryptoUtils";
import { getCellData, getFormatedDate } from "../../../services/commonFunction";

const ShowCustomListingPopup = ({
    setIsViewOpen,
    tabledata = [],
    header = {},
    useFor = '',
    setShowAlertPopup
}) => {
    const navigate = useNavigate();

    const getValue = (field, singleData) => {
        let display_value = singleData[field.name];
        if(!display_value){
            return getCellData(display_value)
        }
        if (typeof display_value === 'object') {
            display_value = singleData[field.name][field.fieldName]
        }
        if (field.type === "date") {
            display_value = getFormatedDate(
                display_value,
                1,
                "",
                field?.isShowColorifPassed,
            )
        }
        else if (field.type === "boolean") {
            if (field.isCustomLabel) {
                display_value =
                    header.options.find(
                        (opt) => opt.value === display_value,
                    )?.label || display_value
            }
            else {
                display_value = display_value ? "Yes" : "No";
                if (field.isNagativeValue) {
                    display_value = display_value === "Yes" ? "No" : "Yes"
                }
            }
        }
        if (useFor == "item-stock-alert") {
            if (['item_rm_code'].includes(field.name)) {
                return <a
                    href="#"
                    className="customViewPopuplink"
                    onClick={(e) => {
                        e.preventDefault();
                        setShowAlertPopup(false)
                        navigate(`/chemicalStocks?filterList=${encryptDataForURL("fk_item_id__item_rm_code__icontains" + "-" + singleData[field.name])}`)
                    }}
                >{singleData[field.name]}</a>
            }
        }
        return getCellData(display_value)
    };
    return (
        <div className="popupSearchContainerBG po-custom-creation">
            <div className="popupInwardModal popupWidthAdjustmentParamDetails renderListSub-popup">
                <div className="rejectSearchCross">
                    <button
                        onClick={() => setIsViewOpen(false)}
                        className="nonNativeButton2"
                        aria-label="Reject Button"
                    >
                        <i className="bi bi-x-lg h4"></i>
                    </button>
                </div>
                <Row className="autoWidthImportant sampleverification-table">
                    <h2 className="modalHeader">{header?.title || "Item Details"}</h2>
                    <table className="table table-white responsive borderless no-wrap mt-3 align-middle renderTable">
                        <thead>
                            <tr>
                                <th>Sr. No.</th>
                                {header?.fields?.map((field, fieldIndex) => {
                                    return <th key={`field-${fieldIndex}`}>{field.label}</th>;
                                })}
                            </tr>
                        </thead>
                        <tbody>
                            {
                                tabledata.map((singleData, rowindex) => {
                                    return (
                                        <tr>
                                            <td>{rowindex + 1}</td>
                                            {
                                                header.fields.map((field, fieldIndex) => {
                                                    return (
                                                        <>

                                                            <td key={`field-${fieldIndex}`}>
                                                                {getValue(field, singleData)}
                                                            </td>
                                                        </>
                                                    );
                                                })
                                            }
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </Row>
                <div className="popupInwardButtonsContainer">
                    <div className="popupSearchButtons">
                        <button type="button" onClick={() => setIsViewOpen(false)}>
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default ShowCustomListingPopup;
